import { type DealTrackingLimitedPartnerBreakdown } from "@vega-api/generated/types/dealTrackingLimitedPartnerBreakdown";

export const areAllNdasSigned = (
  trackingItem: Pick<
    DealTrackingLimitedPartnerBreakdown,
    "numberOfNdasIssued" | "numberOfNdasSigned"
  >,
): boolean =>
  trackingItem.numberOfNdasIssued > 0 &&
  trackingItem.numberOfNdasSigned === trackingItem.numberOfNdasIssued;

export const hasUnsignedNdas = (
  trackingItem: Pick<
    DealTrackingLimitedPartnerBreakdown,
    "numberOfNdasIssued" | "numberOfNdasSigned"
  >,
): boolean =>
  trackingItem.numberOfNdasIssued > 0 &&
  trackingItem.numberOfNdasSigned < trackingItem.numberOfNdasIssued;
